import { PointCloudContentState } from '../state/point-cloud-content-state';

export function getSensorLocation(state: PointCloudContentState) {
  return state.locations?.[state.render.frameNumber]?.position || [0, 0, 0];
}
